import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Produto } from 'app/interfaces/enum/produto.enum';
import { Moeda } from 'app/interfaces/moeda';
import { MoedaTaxa } from 'app/interfaces/moeda-taxa';
import { Pageable } from 'app/interfaces/Pageable/pageable';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MoedaTaxaHttpService {
  constructor(private _http: HttpClient) {}

  /**
   * Função para buscar todas moedataxas;
   * @param filtro
   * @param page
   * @returns
   */
  getAll(filtro = {}, page = 0) {
    const params = { ...filtro, page: page };
    return this._http.get<Pageable>(`${environment.apiUrl}/api/location/v1/moedas-taxas`, { params });
  }

  getPtaxByMoedaOrigemId(moedaOrigemId: number) {
    return this._http.get<Pageable>(`${environment.apiUrl}/api/location/v1/moedas-taxas/ptax?moedaOrigemId=${moedaOrigemId}`);
  }

  getAberturaByMoedaOrigemId(moedaOrigemId: number) {
    return this._http.get<Pageable>(`${environment.apiUrl}/api/location/v1/moedas-taxas/abertura?moedaOrigemId=${moedaOrigemId}`);
  }

  getPtaxByMoedaOrigemIdAndData(moedaOrigemId: number, dataEnvio: string) {
    return this._http.get<MoedaTaxa>(
      `${environment.apiUrl}/api/location/v1/moedas-taxas/ptax-historico?moedaOrigemId=${moedaOrigemId}&moedaDestinoId=124&data=${dataEnvio}`
    );
  }

  findLastPtaxByMoedaOrigemIdMoedaDestinoId(
    moedaOrigemId: number,
    moedaDestinoId: number,
    dataVencimento: string,
    parceiroNegocioSacadoId: number,
    produto: Produto
  ) {
    let params = {
      moedaOrigemId: moedaOrigemId,
      moedaDestinoId: moedaDestinoId,
      data: dataVencimento,
      parceiroNegocioSacadoId: parceiroNegocioSacadoId,
      produto: produto ? produto : '',
    };

    return this._http.get<MoedaTaxa>(`${environment.apiUrl}/api/location/v1/moedas-taxas/ptax-moeda-origem-destino-data`, { params });
  }

  atualizarMoedas() {
    return this._http.get<Pageable>(`${environment.apiUrl}/api/location/v1/moedas-taxas/atualiza-moedas`);
  }

  findPtaxByMoedaOrigemAndDestinoSigla(siglaMoedaOrigem: string, siglaMoedaDestino: string) {
    return this._http.get<MoedaTaxa>(
      `${environment.apiUrl}/api/location/v1/moedas-taxas/ptax-by-sigla-moedas?siglaMoedaOrigem=${siglaMoedaOrigem}&siglaMoedaDestino=${siglaMoedaDestino}`
    );
  }

  getPtaxBrlByData(data: string) {
    return this._http.get<MoedaTaxa[]>(`${environment.apiUrl}/api/location/v1/moedas-taxas/all-ptax-brl-historico?data=${data}`);
  }
}
